import { authTokenApi } from '@xstudios/xapp-auth/services/authService'

export async function getMe() {
  const { data } = await authTokenApi.get('/me')
  return data
}
